<div class="page-header flex flex-column align-items-center">
  <h1 class="m-0">Scholarship Finder — <span>Map View</span></h1>
  
  <!-- View Toggle Bar (Restored) -->
  <div class="flex border-round overflow-x-auto bg-white mt-4 w-full sm:w-auto" style="border: 1px solid var(--border-color); max-width: calc(100vw - 32px);">
    <div class="flex flex-nowrap min-w-max">
      <button class="p-link px-4 py-2 font-medium text-sm transition-colors flex-1"
        routerLink="/portal/scholarships"
        [ngStyle]="{'background-color': !myScholarshipsOnly && viewMode==='cards' ? 'var(--blue-color)' : 'transparent', 'color': !myScholarshipsOnly && viewMode==='cards' ? 'white' : 'var(--text-color)'}">
        <i class="pi pi-id-card mr-2" style="font-size: 1.1rem; vertical-align: middle;"></i> <span
          style="vertical-align: middle;">Cards</span>
      </button>
      <button class="p-link px-4 py-2 font-medium text-sm border-left-1 border-right-1 transition-colors flex-1"
        style="border-color: var(--border-color) !important;"
        routerLink="/portal/deadline-calendar"
        [ngStyle]="{'background-color': !myScholarshipsOnly && viewMode==='calendar' ? 'var(--blue-color)' : 'transparent', 'color': !myScholarshipsOnly && viewMode==='calendar' ? 'white' : 'var(--text-color)'}">
        <i class="pi pi-calendar mr-2" style="font-size: 1.1rem; vertical-align: middle;"></i> <span
          style="vertical-align: middle;">Calendar</span>
      </button>
      <button class="p-link px-4 py-2 font-medium text-sm border-right-1 transition-colors flex-1"
        style="border-color: var(--border-color) !important;"
        (click)="goToMap()"
        [ngStyle]="{'background-color': !myScholarshipsOnly && viewMode==='map' ? 'var(--blue-color)' : 'transparent', 'color': !myScholarshipsOnly && viewMode==='map' ? 'white' : 'var(--text-color)'}">
        <i class="pi pi-map-marker mr-2" style="font-size: 1.1rem; vertical-align: middle;"></i> <span
          style="vertical-align: middle;">Map</span>
      </button>
      <button class="p-link px-4 py-2 font-medium text-sm transition-colors flex-1"
        routerLink="/portal/scholarships" [queryParams]="{ myScholarships: true }"
        [ngStyle]="{'background-color': myScholarshipsOnly ? '#28a745' : 'transparent', 'color': myScholarshipsOnly ? 'white' : 'var(--text-color)'}">
        <i class="pi pi-bookmark mr-2" style="font-size: 1.1rem; vertical-align: middle;"></i> <span
          style="vertical-align: middle;">My Scholarships</span>
      </button>
    </div>
  </div>
</div>

<div class="w-full">
  <div *ngIf="isLoading" class="w-full flex justify-content-center py-8">
    <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="6" animationDuration=".6s"></p-progressSpinner>
  </div>

  <div *ngIf="!isLoading" class="w-full bg-white relative overflow-hidden" style="height: calc(100vh - 180px);">
    
    <!-- Map Legend -->
    <div class="map-legend">
      <h4>Scholarship Density</h4>
      <div class="legend-items">
        <div class="legend-item">
          <div class="color-box" style="background: #4f46e5;"></div>
          <span>High (> 80%)</span>
        </div>
        <div class="legend-item">
          <div class="color-box" style="background: #818cf8;"></div>
          <span>Medium (40-80%)</span>
        </div>
        <div class="legend-item">
          <div class="color-box" style="background: #c7d2fe;"></div>
          <span>Low (< 40%)</span>
        </div>
        <div class="legend-item">
          <div class="color-box" style="background: #f1f5f9; border: 1px solid #e2e8f0;"></div>
          <span>None</span>
        </div>
      </div>
    </div>

    <div class="h-full w-full"
         leaflet
         [leafletOptions]="mapOptions"
         [leafletLayers]="layers"
         (leafletMapReady)="onMapReady($event)">
    </div>

  </div>
</div>


